import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { RegistrationStep } from 'angular-lib';

@Component({
    selector: 'ez-born-date',
    template: require('./born-date.component.html'),
    styles: [require('./born-date.component.less')]
})
export class BornDateComponent extends RegistrationStep implements OnInit {
    public formattedDate: string;
    public errorType: string;
    public numbers: number[] = Array.from(new Array(82), (x,i) => i + 18);
    public age: number = 35;

    public ngOnInit() {
        if (!this.registrationModel.bornDate) {
            this.registrationModel.bornDate = moment().subtract(35, 'years').format('YYYY-MM-DD');
        }

        this.formattedDate = moment(this.registrationModel.bornDate).format('YYYY-MM-DD');
    }

    public changed() {
        this.registrationModel.bornDate = moment().subtract(30, 'days').subtract(this.age, 'years').format('YYYY-MM-DD');
    }

    public validBornDate() {
        this.submit();
    }
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./src/app/components/registration/born-date/born-date.component.ts